module.exports = __webpack_public_path__ + "img/D3.38196725.svg";